import React from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";

import StudentList from "../../../templates/teacher/StudentList";
import {
  Context,
  fetchStudents,
  notFoundPath,
  classDataPath,
  clearStudents,
} from "../../../teacherStore";

export default () => {
  const { state: locationState } = useLocation<{
    nameClass: string;
  }>();
  const history = useHistory();
  const { state, dispatch } = React.useContext(Context);
  const params = useParams<{ class_id: string }>();
  const class_id = parseInt(params.class_id);
  const nameClass = locationState?.nameClass;

  React.useEffect(() => {
    if (!nameClass) {
      history.replace(notFoundPath);
    }
  }, [history, nameClass]);

  React.useEffect(() => {
    dispatch(fetchStudents([class_id]));
    return () => dispatch(clearStudents());
  }, [class_id, dispatch]);

  const links = React.useMemo(
    () => [
      {
        name: `クラスデータ`,
        to: classDataPath,
      },
      {
        name: nameClass ?? "",
        to: "#",
      },
    ],
    [nameClass],
  );

  const goToDownloadPDF = React.useCallback(
    () =>
      history.push(`${classDataPath}/${class_id}/download_all_portfolio`, {
        nameClass,
      }),
    [class_id, history, nameClass],
  );

  const goToDownloadCSV = React.useCallback(
    () =>
      history.push(`${classDataPath}/${class_id}/downloadCSV`, {
        nameClass,
      }),
    [class_id, history, nameClass],
  );

  const goToDownloadLeafPDF = React.useCallback(
    () =>
      history.push(`${classDataPath}/${class_id}/download_leaf_pdf`, {
        nameClass,
      }),
    [class_id, history, nameClass],
  );

  const goBack = React.useCallback(() => history.push(classDataPath), [
    history,
  ]);

  const goToStudentResponse = React.useCallback(
    student =>
      history.push(
        `${classDataPath}/${class_id}/student/${student.id}/response`,
        {
          students: state.students,
          nameClass,
        },
      ),
    [class_id, history, nameClass, state.students],
  );

  return nameClass ? (
    <StudentList
      surveyEnabled={state.survey_enabled}
      listStudents={state.students}
      nameClass={nameClass}
      isActiveDownloadMenu={true}
      links={links}
      goBack={goBack}
      goToDownloadCSV={goToDownloadCSV}
      goToDownloadPDF={goToDownloadPDF}
      goToDownloadLeafPDF={goToDownloadLeafPDF}
      goToStudentResponse={goToStudentResponse}
    />
  ) : null;
};
